<template>
<div class="footer-section">
    <a rel="noopener" aria-label="Discord" target="_blank" :href="icons.discord.link"><img class="icon-svg" :src="icons.discord.icon" alt="discord link"></a>
    <a rel="noopener" aria-label="Telegram" target="_blank" :href="icons.telegram.link"><img class="icon-svg" :src="icons.telegram.icon" alt="telegram link"></a>
    <p style="margin-top: 10px; font-size: 0.7rem; padding-left: 15px; padding-right: 15px; margin-bottom: 0px; color: #9198aa">As an Amazon Associate I earn from qualifying purchases.</p>
    <p style="margin-top: 8px; font-size: 0.72rem; margin-bottom: 0px;">
        <a class="footer-link" rel="noopener" target="_blank" href="https://gixcore.com/privacy.html">Privacy Policy</a>
        <span style="color:#434857;">&nbsp;·&nbsp;</span>
        <a class="footer-link" rel="noopener" target="_blank" href="https://gixcore.com/terms.html">Terms of Service</a>
    </p>
</div>
    
</template>

<script>
export default {
    name: "Footer", 
    data(){
        return {
            icons: {
                discord: {
                    icon: require('../../img/discord.svg'),
                    link: 'https://discord.gg/aDQXxWsYND'
                },
                telegram: {
                    icon: require('../../img/telegram.svg'),
                    link: 'https://t.me/+yDlHq_ejNZ1jN2Mx'
                },
            }
        }
    }
}
</script>

<style scoped>

.footer-section {
    border-top: 1px solid #434857;
    border-bottom: 1px solid #434857;
    display: block;
    margin-right: auto;
    margin-left: auto;
    margin-top: 6px;
    text-align: center;
    padding: 5px;
    padding-top: 16px;
    padding-bottom: 16px;
}
.icon-svg {
    height: 24px;
    fill: #9198aa;
    filter: invert(68%) sepia(21%) saturate(226%) hue-rotate(185deg) brightness(85%) contrast(90%);
    margin-left: 15px;
    margin-right: 15px;
    cursor: pointer;
    transition: 0.2s
}
.icon-svg:hover {
    filter: invert(52%) sepia(85%) saturate(604%) hue-rotate(158deg) brightness(92%) contrast(88%);
}
.footer-link {
    color: #9198aa;
    text-decoration: none;
}
.footer-link:hover {
    color: #1997c6;
}
</style>
